export default "__VITE_ASSET__18bc9cdc__"